import {getQueryFilter} from 'utils/helper'
import {STATUS_PAGE} from './endpoint'
import {
  ADD_INCIDENTS,
  ADD_INCIDENTS_SOURCE,
  ADD_INCIDENTS_STATUS,
  ADD_MAINTAINANCE,
  ADD_SERVICES_COMPO,
  ADD_STATUS_TEMPLATES,
  ADD_SUBSCRIBER,
  CREATE_STATUS_PAGE,
  DELETE_INCIDENTS,
  DELETE_INCIDENTS_SOURCE,
  DELETE_INCIDENTS_STATUS,
  DELETE_MAINTAINANCE,
  DELETE_SERVICES_COMPO,
  DELETE_STATUS_PAGE,
  DELETE_STATUS_TEMPLATES,
  DELETE_SUBSCRIBER,
  GET_ALL_COMPO_GROUP,
  GET_ALL_INCIDENTS,
  GET_ALL_INCIDENTS_SOURCE,
  GET_ALL_INCIDENTS_STATUS,
  GET_ALL_MAINTAINANCE,
  GET_ALL_SERVICES,
  GET_ALL_SUBSCRIBER,
  GET_ALL_TEMPLATES,
  GET_PAGE_SETTINGS,
  GET_SINGLE_COMPO,
  GET_SINGLE_INCIDENTS,
  GET_SINGLE_MAINTAINANCE,
  GET_SINGLE_TEMPLATES,
  GET_STATUS_EMBED,
  GET_STATUS_GENERAL,
  TOGGEL_SUBSCRIBER_EMAIL,
  UPDATE_INCIDENTS,
  UPDATE_INCIDENTS_SOURCE,
  UPDATE_INCIDENTS_STATUS,
  UPDATE_MAINTAINANCE,
  UPDATE_SERVICES_COMPO,
  UPDATE_STATUS_EMBED,
  UPDATE_STATUS_GENERAL,
  UPDATE_STATUS_TEMPLATES,
  UPDATE_SUBSCRIBER,
  UPDATE_PAGE_SETTINGS,
  UPLOAD_LOGO_STATUS,
  DELETE_LOGO_STATUS,
  UPLOAD_FAVICON_STATUS,
  DELETE_FAVICON_STATUS,
  UPDATE_MAINTAINANCE_STATUS,
} from './types'
import {apiAction} from './api'

export function getAllIncidentsSource() {
  return apiAction({
    url: `${STATUS_PAGE}/incidents/source`,
    method: 'GET',
    label: GET_ALL_INCIDENTS_SOURCE,
  })
}
export function addIncidentSource(data) {
  return apiAction({
    url: `${STATUS_PAGE}/incidents/source`,
    method: 'POST',
    label: ADD_INCIDENTS_SOURCE,
    data,
    showToast: true,
    successMessage: 'Incident Source Added',
  })
}

export function deleteIncidentSource(id) {
  return apiAction({
    url: `${STATUS_PAGE}/incidents/source/${id}`,
    method: 'DELETE',
    label: DELETE_INCIDENTS_SOURCE,
    showToast: true,
    successMessage: 'Incident Source Deleted',
    reduxData: {sourceId: id},
  })
}

export function updateIncidentSource(id, data) {
  return apiAction({
    url: `${STATUS_PAGE}/incidents/source/${id}`,
    method: 'PUT',
    label: UPDATE_INCIDENTS_SOURCE,
    data,
    showToast: true,
    successMessage: 'Incident Source Updated',
  })
}

export function getAllIncidentsStatus() {
  return apiAction({
    url: `${STATUS_PAGE}/incidents/status`,
    method: 'GET',
    label: GET_ALL_INCIDENTS_STATUS,
  })
}
export function addIncidentStatus(data) {
  return apiAction({
    url: `${STATUS_PAGE}/incidents/status`,
    method: 'POST',
    label: ADD_INCIDENTS_STATUS,
    data,
    showToast: true,
    successMessage: 'Incident Status Added',
  })
}

export function deleteIncidentStatus(id) {
  return apiAction({
    url: `${STATUS_PAGE}/incidents/status/${id}`,
    method: 'DELETE',
    label: DELETE_INCIDENTS_STATUS,
    showToast: true,
    successMessage: 'Incident Status Deleted',
    reduxData: {statusId: id},
  })
}

export function updateIncidentStatus(id, data) {
  return apiAction({
    url: `${STATUS_PAGE}/incidents/status/${id}`,
    method: 'PUT',
    label: UPDATE_INCIDENTS_STATUS,
    data,
    showToast: true,
    successMessage: 'Incident Status Updated',
  })
}

export function getAllSubscriber() {
  return apiAction({
    url: `${STATUS_PAGE}/subscribers`,
    method: 'GET',
    label: GET_ALL_SUBSCRIBER,
  })
}

export function addSubscriber(data) {
  return apiAction({
    url: `${STATUS_PAGE}/subscribers`,
    method: 'POST',
    label: ADD_SUBSCRIBER,
    data,
    showToast: true,
    successMessage: 'Subscribers Added',
  })
}

export function deleteSubscriber(id) {
  return apiAction({
    url: `${STATUS_PAGE}/subscribers/${id}`,
    method: 'DELETE',
    label: DELETE_SUBSCRIBER,
    showToast: true,
    successMessage: 'Subscriber Deleted',
  })
}

export function updateSubscriber(id, data) {
  return apiAction({
    url: `${STATUS_PAGE}/subscribers/${id}`,
    method: 'PUT',
    label: UPDATE_SUBSCRIBER,
    data,
    showToast: true,
    successMessage: 'Subscriber Updated',
  })
}

export function toggelSubscriberEmail(id) {
  return apiAction({
    url: `${STATUS_PAGE}/subscribers/status/${id}`,
    method: 'PUT',
    label: TOGGEL_SUBSCRIBER_EMAIL,
    showToast: true,
    successMessage: 'Subscribers Status Updated',
  })
}

export function getAllServices() {
  return apiAction({
    url: `${STATUS_PAGE}/services`,
    method: 'GET',
    label: GET_ALL_SERVICES,
  })
}

export function addServicesCompo(data) {
  return apiAction({
    url: `${STATUS_PAGE}/services/add`,
    method: 'POST',
    label: ADD_SERVICES_COMPO,
    data,
    showToast: true,
    successMessage: 'Services Added',
  })
}

export function getCompoGroup() {
  return apiAction({
    url: `${STATUS_PAGE}/services/groups`,
    method: 'GET',
    label: GET_ALL_COMPO_GROUP,
  })
}

export function deleteServicesCompo(data) {
  return apiAction({
    url: `${STATUS_PAGE}/services/service`,
    method: 'DELETE',
    label: DELETE_SERVICES_COMPO,
    showToast: true,
    successMessage: 'Service Component Deleted',
    data,
  })
}

export function getsingleCompo(CompoType, id) {
  return apiAction({
    url: `${STATUS_PAGE}/services/${CompoType}/${id}`,
    method: 'GET',
    label: GET_SINGLE_COMPO,
  })
}

export function updateServicesCompo(id, CompoType, data) {
  return apiAction({
    url: `${STATUS_PAGE}/services/${CompoType}/${id}`,
    method: 'PUT',
    label: UPDATE_SERVICES_COMPO,
    data,
    showToast: true,
    successMessage: 'Service Component Updated',
  })
}

export function getAllTemplates(params) {
  let url = `${STATUS_PAGE}/templates`
  const qs = getQueryFilter(params)
  if (qs) url += `?${qs}`

  return apiAction({
    url,
    method: 'GET',
    label: GET_ALL_TEMPLATES,
  })
}

export function deleteStatusTemplates(id) {
  return apiAction({
    url: `${STATUS_PAGE}/templates/${id}`,
    method: 'DELETE',
    label: DELETE_STATUS_TEMPLATES,
    showToast: true,
    successMessage: 'Template Deleted',
  })
}

export function addStatusTemplates(data) {
  return apiAction({
    url: `${STATUS_PAGE}/templates`,
    method: 'POST',
    label: ADD_STATUS_TEMPLATES,
    data,
    showToast: true,
    successMessage: 'Template Added',
  })
}

export function getSingleTemplates(id) {
  return apiAction({
    url: `${STATUS_PAGE}/templates/template/${id}`,
    method: 'GET',
    label: GET_SINGLE_TEMPLATES,
  })
}

export function updateStatusTemplates(id, data) {
  return apiAction({
    url: `${STATUS_PAGE}/templates/${id}`,
    method: 'PUT',
    label: UPDATE_STATUS_TEMPLATES,
    data,
    showToast: true,
    successMessage: 'Template Updated',
  })
}

export function getStatusEmbed() {
  return apiAction({
    url: `${STATUS_PAGE}/embed`,
    method: 'GET',
    label: GET_STATUS_EMBED,
  })
}

export function updateStatusEmbed(id, data) {
  return apiAction({
    url: `${STATUS_PAGE}/embed/${id}`,
    method: 'PUT',
    data,
    label: UPDATE_STATUS_EMBED,
    showToast: true,
    successMessage: 'Status Embed Updated',
  })
}

export function getStatusGeneral() {
  return apiAction({
    url: `${STATUS_PAGE}/setting/custom-url`,
    method: 'GET',
    label: GET_STATUS_GENERAL,
  })
}

export function updateStatusGeneral(data) {
  return apiAction({
    url: `${STATUS_PAGE}/setting/custom-url`,
    method: 'PUT',
    data,
    label: UPDATE_STATUS_GENERAL,
    showToast: true,
    successMessage: 'Status General Updated',
  })
}

export function getAllIncidents(params = {}) {
  const keys = Object.keys(params || {})

  const query = keys
    .filter(key => params[key])
    .map(key => `${key}=${params[key]}`)
    .join('&')
  return apiAction({
    url: `${STATUS_PAGE}/incidents${query ? `?${query}` : ''}`,
    method: 'GET',
    label: GET_ALL_INCIDENTS,
  })
}

export function addIncidents(data) {
  return apiAction({
    url: `${STATUS_PAGE}/incidents/incident`,
    method: 'POST',
    label: ADD_INCIDENTS,
    data,
    showToast: true,
    successMessage: 'Incidents Added',
  })
}

export function deleteIncidents(id) {
  return apiAction({
    url: `${STATUS_PAGE}/incidents/incident/${id}`,
    method: 'DELETE',
    label: DELETE_INCIDENTS,
    showToast: true,
    successMessage: 'Incidents Deleted',
  })
}

export function updateIncidents(id, data) {
  return apiAction({
    url: `${STATUS_PAGE}/incidents/incident/${id}`,
    method: 'PUT',
    data,
    label: UPDATE_INCIDENTS,
    showToast: true,
    successMessage: 'Incidents Updated',
  })
}

export function getSingleIncidents(id) {
  return apiAction({
    url: `${STATUS_PAGE}/incidents/incident/${id}`,
    method: 'GET',
    label: GET_SINGLE_INCIDENTS,
  })
}

export function getAllMaintainance(params = {}) {
  const keys = Object.keys(params || {})

  const query = keys
    .filter(key => params[key])
    .map(key => `${key}=${params[key]}`)
    .join('&')
  return apiAction({
    url: `${STATUS_PAGE}/maintenance${query ? `?${query}` : ''}`,
    method: 'GET',
    label: GET_ALL_MAINTAINANCE,
  })
}

export function addMaintainance(data) {
  return apiAction({
    url: `${STATUS_PAGE}/maintenance`,
    method: 'POST',
    label: ADD_MAINTAINANCE,
    data,
    showToast: true,
    successMessage: 'Maintainance Added',
  })
}

export function deleteMaintainance(id) {
  return apiAction({
    url: `${STATUS_PAGE}/maintenance/${id}`,
    method: 'DELETE',
    label: DELETE_MAINTAINANCE,
    showToast: true,
    successMessage: 'Maintainance Deleted',
  })
}

export function updateMaintainance(id, data) {
  return apiAction({
    url: `${STATUS_PAGE}/maintenance/${id}`,
    method: 'PUT',
    data,
    label: UPDATE_MAINTAINANCE,
    showToast: true,
    successMessage: 'Maintainance Updated',
  })
}

export function updateMaintainanceStatus(id, data) {
  return apiAction({
    url: `${STATUS_PAGE}/maintenance/${id}`,
    method: 'PUT',
    data,
    label: UPDATE_MAINTAINANCE_STATUS,
    showToast: true,
    successMessage: 'Maintainance Status Updated',
  })
}

export function getSingleMaintainance(id) {
  return apiAction({
    url: `${STATUS_PAGE}/maintenance/${id}`,
    method: 'GET',
    label: GET_SINGLE_MAINTAINANCE,
  })
}

export function getPageSettings() {
  return apiAction({
    url: `${STATUS_PAGE}/setting`,
    method: 'GET',
    label: GET_PAGE_SETTINGS,
  })
}

export function updatePageSettings(id, data) {
  return apiAction({
    url: `${STATUS_PAGE}/setting/${id}`,
    method: 'PUT',
    data,
    label: UPDATE_PAGE_SETTINGS,
    showToast: true,
    successMessage: 'Page Settings Updated',
  })
}

export function uploadLogoStatus(data) {
  return apiAction({
    url: `${STATUS_PAGE}/setting/upload`,
    method: 'POST',
    label: UPLOAD_LOGO_STATUS,
    contentType: 'multipart/form-data',
    data,
  })
}

export function deleteLogoStatus(id, url) {
  return apiAction({
    url: `${STATUS_PAGE}/setting/upload?uploadUrl=${url}&id=${id}&type=logo`,
    method: 'DELETE',
    label: DELETE_LOGO_STATUS,
  })
}

export function uploadFaviconStatus(data) {
  return apiAction({
    url: `${STATUS_PAGE}/setting/upload`,
    method: 'POST',
    label: UPLOAD_FAVICON_STATUS,
    contentType: 'multipart/form-data',
    data,
  })
}

export function deleteFaviconStatus(id, url) {
  return apiAction({
    url: `${STATUS_PAGE}/setting/upload?uploadUrl=${url}&id=${id}&type=favicon`,
    method: 'DELETE',
    label: DELETE_FAVICON_STATUS,
  })
}

export function addStatusPage(data) {
  return apiAction({
    url: `${STATUS_PAGE}/setting`,
    method: 'POST',
    label: CREATE_STATUS_PAGE,
    data,
    showToast: true,
    successMessage: 'Status Page Added',
  })
}

export function deleteStatusPage(id) {
  return apiAction({
    url: `${STATUS_PAGE}/setting/${id}`,
    method: 'DELETE',
    label: DELETE_STATUS_PAGE,
    showToast: true,
    successMessage: 'Status Page Deleted',
  })
}
